import { ApiUtility, IApiResponse } from "../Utilities/ApiUtility.axios";
export enum TicketModule {
  Unknown = 0,
  AML = 1,
  Billing = 2,
  Books = 3,
  CRM = 4,
  PAYE = 5,
  SA = 6,
  Accounts = 7,
}
export enum TicketStatus {
  Unknown = 0,
  Open = 1,
  Resolved = 2,
  Closed = 3,
  Archived = 4,
  Deleted = 5,
  UnderResearch = 6,
  InProgress = 7,
  InTesting = 8,
  ReadyForRelease = 9,
  Escalated = 10,
  Waiting = 11,
}
export enum TicketPriority {
  Unknown = 0,
  Low = 1,
  Normal = 2,
  High = 3,
  Emergency = 4,
}
class TicketService {
  route = "api/Tickets";
  deEscalate = async (id: string, reason: string) => {
    return ApiUtility.post<IApiResponse<string>>(
      `${this.route}/${id}/DeEscalate`,
      {
        reason,
        expectedVersion: 0,
      },
    );
  };

  resolve = async (id: string, reason: string) => {
    return ApiUtility.post<IApiResponse<boolean>>(
      `${this.route}/${id}/Resolve`,
      {
        reason,
      },
    );
  };

  getList = (
    start: number,
    length: number,
    status: number,
    search: string,
    sortCol: string,
    sortDir: string,
    priority?: number,
    dateType?: string,
    fromDate?: any,
    toDate?: any,
    type?: number,
    inputValue?: boolean | null,
    module?: TicketModule,
  ) => {
    return ApiUtility.getResult(this.route, {
      start,
      length,
      status,
      priority,
      search,
      sortCol,
      sortDir,
      dateType,
      fromDate,
      toDate,
      type,
      inputValue,
      incoming: false,
      module,
      _t: Date.now(),
    });
  };

  get = (id: string) => {
    return ApiUtility.getResult<ITicket>(`${this.route}/${id}`, {
      _t: Date.now(),
    });
  };

  postReply = (id: string, message: string) => {
    return ApiUtility.post<IApiResponse<boolean>>(`${this.route}/${id}/Reply`, {
      message,
    });
  };
}

export interface ITicket {
  id: string;
  number: string;
  title: string;
  message: string;
  status: TicketStatus;
  ticketLevel: number;
  isEscalated: boolean;
  module: number;
  priority: number;
  issueType: number;
  createdBy: {
    userId: string;
    userName: string;
    date: string;
  };
  company: {
    id: string;
    name: string;
  };
  thread: ITicketThreadItem[];
  attachments: any[];
}
export interface ITicketThreadItem {
  id: string;
  poster: {
    id: string;
    name: string;
    type: TicketPosterType;
  };
  body: string;
  createdAt: string;
  isSystem: boolean;
}
export enum TicketPosterType {
  Client = 1,
  PracticeStaff = 2,
  Admin = 3,
}

export default new TicketService();
